import { Controller } from "@hotwired/stimulus"
import { flash } from "./flash_controller";

export default class extends Controller {
  static values = { type: String, message: String }

  connect() {
    if (this.typeValue && this.messageValue) {
      setTimeout(() => flash(this.typeValue, this.messageValue), 0)
    }

    this.element.remove()
  }
}
